import React from 'react';
import { Modal, Form, DatePicker, Radio, Button } from 'antd';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { updateUserLeaveStatus } from '../redux/slice';
import styles from '../../Dashboard/index.module.less';

const { RangePicker } = DatePicker;

const LeaveModal = ({ visible, onClose, member, onSuccess }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    const [start, end] = values.leave_date;

    const startDate = start.format('YYYY-MM-DD');
    const endDate = end.format('YYYY-MM-DD');

    // const isSingleDay = start.isSame(end, 'day');

    const payload = {
      id: Number(member.id),
      // on_leave: true,
      leave_start_date: startDate,
      leave_end_date: endDate
      // ...(isSingleDay && { leave_type: values.leave_type })
    };

    dispatch(updateUserLeaveStatus(payload)).then((res) => {
      if (res?.payload?.success) {
        form.resetFields();
        onSuccess?.(); // refreshes members (e.g. handleGetAllUsers in taskPlanner)
        onClose();
      }
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  // const handleValuesChange = (changedValues, allValues) => {
  //   if (changedValues.leave_date) {
  //     const range = changedValues.leave_date;
  //     if (range && range[0] && range[1] && range[0].isSame(range[1], 'day')) {
  //       form.setFieldsValue({ leave_type: 'FULL' });
  //     }
  //   }
  // };

  return (
    <Modal
      visible={visible}
      closable={false}
      footer={null}
      centered
      destroyOnClose
      width={420}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        // onValuesChange={handleValuesChange}
      >
        <h3 className="font-bold mb-3 text-[#000000d9]">
          Allocating Leave to Member
        </h3>

        {/* LEAVE DATE (START + END) */}
        <Form.Item
          label="Leave Date"
          name="leave_date"
          rules={[{ required: true, message: 'Select leave date' }]}
          className={styles.customLable}
        >
          <RangePicker
            style={{ width: '100%' }}
            disabledDate={(current) =>
              current && current < moment().startOf('day')
            }
          />
        </Form.Item>

        {/* LEAVE DURATION - commented out for now */}
        {/* <Form.Item
          shouldUpdate={(prev, curr) => prev.leave_date !== curr.leave_date}
        >
          {({ getFieldValue }) => {
            const range = getFieldValue('leave_date');

            if (!range) return null;

            const isSingleDay = range[0].isSame(range[1], 'day');

            return (
              isSingleDay && (
                <Form.Item
                  label="Leave Duration"
                  name="leave_type"
                  rules={[{ required: true, message: 'Select leave type' }]}
                  className={styles.customLable}
                >
                  <Radio.Group>
                    <Radio value="FULL">Full day</Radio>
                    <Radio value="FIRST_HALF">First half</Radio>
                    <Radio value="SECOND_HALF">Second half</Radio>
                  </Radio.Group>
                </Form.Item>
              )
            );
          }}
        </Form.Item> */}

        <div className="flex justify-center gap-3 mt-4">
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default LeaveModal;
